import React, { useState } from 'react';
import BEMHelper from '@ynap/bem-helper';
import PropTypes from 'prop-types';

const bem = new BEMHelper('ToggleSlide');

const ToggleSlide = ({ textLeft, textRight, onToggle, hasDisableState, className }) => {
    const { toggleClass = className, textClass = null, sliderClass = null } = className || '';

    const [isToggleEnabled, setIsToggleEnabled] = useState(false);

    const toggle = () => {
        setIsToggleEnabled(!isToggleEnabled);
        onToggle();
    };

    const disabledModifier = hasDisableState && !isToggleEnabled && 'disabled';

    return (
        <div className={bem(null, null, toggleClass)}>
            <label className={bem('label', null, textClass)}>{textLeft}</label>
            <label className={bem('switch', disabledModifier, sliderClass)}>
                <input type="checkbox" onChange={toggle} />
                <span className={bem('slider')} />
            </label>
            <label className={bem('label', null, textClass)}>{textRight}</label>
        </div>
    );
};

ToggleSlide.propTypes = {
    textLeft: PropTypes.string,
    textRight: PropTypes.string,
    onToggle: PropTypes.func.isRequired,
    hasDisableState: PropTypes.bool,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            toggleClass: PropTypes.string,
            textClass: PropTypes.string,
            sliderClass: PropTypes.string,
        }),
    ]),
};

export default ToggleSlide;
